export default "__VITE_ASSET__Be0USMIn__"